export default __webpack_public_path__ + "static/media/139.581c7665.svg";